<app-pageheader>
  <button class="button is-primary" (click)="save()" [disabled]="isSaving || isLoading || !hasChanges">
    @if (!isSaving) {
      <span>Save Changes</span>
    }
    @if (isSaving) {
      <span>Saving...</span>
    }
  </button>
  <button class="button is-text" (click)="loadWorkflow()" [disabled]="isSaving || isLoading">Reset</button>
</app-pageheader>

<section class="workflow-editor-container">
  @if (isLoading) {
    <div class="loading-indicator">
      <span class="loader"></span>
      <p>Loading workflow…</p>
    </div>
  }

  @if (!isLoading) {
    <app-workflow-editor
      [workflow]="pendingWorkflow || workflow"
      [readonly]="isSaving"
      [availableProperties]="citationConditionProperties"
      (workflowChange)="onWorkflowChange($event)">
    </app-workflow-editor>
    @if (!hasChanges) {
      <div class="notification is-warning mt-4">
        Adjust the workflow above to enable saving.
      </div>
    }
  }
</section>
